/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_New_Reason_InInputs */

const vi_sl_new_reason_in = /** @type {(inputs: Sl_New_Reason_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lý do nhập`)
};

/**

* @param {Sl_New_Reason_InInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_new_reason_in = /** @type {((inputs?: Sl_New_Reason_InInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_New_Reason_InInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_new_reason_in(inputs)
});